import { CompanyLogo } from "../../../styles/component/style";
import { Images } from "../../../assets/images";
import {
  LogoContainer,
  LinksContainer,
  ProfileImage,
  ProfileName,
  LogoutText,
  BigScreen,
  SmallScreen,
  LogoutIcon,
  Row,
  AgentTag,
} from "./Styles";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import COLORS from "../../../assets/Colors";
import useUser from "../../../hooks/useUser";
import { navigate } from "@reach/router";
import labels from "../../../helpers/labels.json";
import useAlert from "../../../hooks/useAlert";
import useSettings from "../../../hooks/useSettings";
import MenuIcon from "@material-ui/icons/Menu";
import IconButton from "@material-ui/core/IconButton";

const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    background: COLORS.PRIMARY_WHITE,
    height: 74,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    boxShadow: "none",
    borderBottom: "1px solid #e1e3ee",
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
}));

export default function StyledAppBar({ showDrawer, setShowDrawer }) {
  const classes = useStyles();
  const { userObject, token, setToken, authSetting } = useUser();
  const { showAlert, hideAlert } = useAlert();
  const { setting, settingsLoading } = useSettings();

  const handleLogout = () =>
    showAlert({
      heading: "Logout?",
      desc: "Are you sure you want to logout?",
      primaryBtnText: "Logout",
      secondaryBtnText: "Cancel",
      clickSecondarybtn: () => hideAlert(),
      clickPrimaryBtn: () => {
        setToken("logged_out");
        hideAlert();
      },
      isOpen: true,
      onDialogClose: () => hideAlert(),
    });

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <LogoContainer>
          {!token
            ? null
            : showDrawer
            ? showDrawer && (
                <IconButton
                  edge="start"
                  color="black"
                  aria-label="menu"
                  onClick={() => setShowDrawer(false)}
                >
                  <MenuIcon style={{ color: `${COLORS.COLOR_DARK}` }} />
                </IconButton>
              )
            : !showDrawer && (
                <IconButton
                  edge="start"
                  color="black"
                  aria-label="menu"
                  onClick={() => setShowDrawer(true)}
                >
                  <MenuIcon style={{ color: `${COLORS.COLOR_DARK}` }} />
                </IconButton>
              )}
          {settingsLoading ? null : (
            <CompanyLogo
              onClick={() =>
                token
                  ? navigate("/transcriber/cases?caseType=mediation")
                  : navigate("/")
              }
              src={
                authSetting?.logoUrl || setting?.logoUrl || Images.companyLogo
              }
            />
          )}
        </LogoContainer>
        <BigScreen>
          <LinksContainer>
            {!token ? null : (
              <>
                <Row onClick={handleLogout}>
                  <LogoutIcon
                    src={require("../../../assets/images/logout.svg")}
                  />
                  <LogoutText>{labels["appbar.logout"]}</LogoutText>
                </Row>
                <ProfileImage
                  src={
                    userObject.avatarUrl
                      ? userObject.avatarUrl
                      : require("../../../assets/images/userPlaceholder.svg")
                  }
                />
                <ProfileName>
                  <div>{userObject.name}</div>
                  <AgentTag>{"Transcriber"}</AgentTag>
                </ProfileName>
                <ProfileName style={{ marginRight: "56px" }} />
              </>
            )}
          </LinksContainer>
        </BigScreen>
        <SmallScreen>
          {!token ? null : (
            <>
              <Row onClick={handleLogout}>
                <LogoutIcon
                  src={require("../../../assets/images/logout.svg")}
                />
                <LogoutText>{labels.logout}</LogoutText>
              </Row>
              <ProfileImage
                src={
                  userObject.avatarUrl
                    ? userObject.avatarUrl
                    : require("../../../assets/images/userPlaceholder.svg")
                }
              />

              <ProfileName>{userObject.name}</ProfileName>
            </>
          )}
        </SmallScreen>
      </Toolbar>
    </AppBar>
  );
}
